import {
  IonCard,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonRow,
} from "@ionic/react";
import {
  addCircle,
  removeCircle,
  tabletLandscape,
  trashOutline,
} from "ionicons/icons";
import { useCart } from "./useCart";
import { NumberMoney } from "../../components/NumberMoney/NumberMoney";
import SubHeader from "../FrameAndEasel/SubHeader";
import { usePictures } from "../Pictures/usePictures";

/** Extra plain frames ordered without a picture. Frames for pictures are chosen on each picture. */
const Frame = () => {
  const { frames, changeFrameNumber } = useCart();

  const { equipmentPrice, equipmentState } = usePictures();
  const disabled = !equipmentState.frame;

  return (
    <IonCard style={{ margin: "3px", padding: "13px 16px 0 16px" }}>
      <SubHeader
        icon={tabletLandscape}
        text="Dodatni blind ram (rasklopljen, bez slike)"
        onTop
        disabled={disabled}
      >
        <NumberMoney value={equipmentPrice.frame} />
      </SubHeader>

      {!disabled && (
        <IonGrid>
          <IonRow>
            <IonCol className="ion-text-right">
              {frames > 0 && (
                <IonIcon
                  className="cursorP"
                  icon={frames === 1 ? trashOutline : removeCircle}
                  size="large"
                  color="primary"
                  onClick={() => changeFrameNumber(frames - 1)}
                />
              )}
            </IonCol>
            <IonCol className="ion-text-center f20 b" style={{ paddingTop: 7 }}>
              <IonLabel>{frames}</IonLabel>
            </IonCol>
            <IonCol className="ion-text-left">
              <IonIcon
                className="cursorP"
                color="primary"
                icon={addCircle}
                size="large"
                onClick={() => changeFrameNumber(frames + 1)}
              />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="f13 ion-text-center">
              Ram za sliku iz korpe birate na samoj slici.
            </IonCol>
          </IonRow>
        </IonGrid>
      )}
      {disabled && (
        <div className="b f15 ion-text-center" style={{ marginBottom: 12 }}>
          <IonLabel>Trenutno nema na stanju</IonLabel>
        </div>
      )}
    </IonCard>
  );
};

export default Frame;
